<template>
  <!-- begin:: Footer -->
  <div class="footer bg-white py-4 d-flex flex-lg-column" id="kt_footer">
    <div class="d-flex align-items-center justify-content-between"
      v-bind:class="{ 'container-fluid': widthFluid, container: !widthFluid }">
      <!-- Copyright © 2021 Klinik Hayandra. All Rights Reserved. 
Powered by Wellmagic Media Digital. -->
      <div class="text-dark">
        <span class="text-muted font-weight-bold mr-2">
          Copyright 2021 &nbsp;&copy;&nbsp;
        </span>
        <span class="text-muted font-weight-bold mr-2">
          Klinik Hayandra. All Rights Reserved.
        </span>
        <a href="https://wellmagic.id/" target="_blank" class="text-dark text-muted font-weight-bold text-hover-primary">
          Powered by Wellmagic Media Digital.
        </a>
      </div>
      <!-- <div class="nav nav-dark">
        <a
          href="http://keenthemes.com/metronic"
          target="_blank"
          class="nav-link pr-3 pl-0"
        >
          About
        </a>
        <a
          href="http://keenthemes.com/metronic"
          target="_blank"
          class="nav-link px-3"
        >
          Team
        </a>
        <a
          href="http://keenthemes.com/metronic"
          target="_blank"
          class="nav-link pl-3 pr-0"
        >
          Contact
        </a>
      </div> -->
    </div>
  </div>
  <!-- end:: Footer -->
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "KTFooter",
  computed: {
    ...mapGetters(["layoutConfig"]),

    /**
     * Check if footer container is fluid
     */
    widthFluid() {
      return this.layoutConfig("footer.width") === "fluid";
    }
  }
};
</script>
